import { Companion } from '../companion.model';
import { CompanionActions, CompanionActionTypes } from '../actions/companion.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface CompanionOverViewState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforCompanionOverView: CompanionOverViewState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface CompanionProtectionProcessDeviceState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforCompanionProtectionProcessDevice: CompanionProtectionProcessDeviceState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface ResendDataOfCompanionProtectionProcessState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforResendDataOfCompanionProtectionProcess: ResendDataOfCompanionProtectionProcessState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: CompanionActions
): State {
  switch (action.type) {

    case CompanionActionTypes.GetCompanions: {
      return {...state, Loaded: false, Loading: true};
    }

    case CompanionActionTypes.UpsertCompanions: {
      return  {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case CompanionActionTypes.GetCompanionsFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case CompanionActionTypes.NoCompanions: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export function companionOverViewReducer(
  state = initialStateforCompanionOverView,
  action: CompanionActions
): CompanionOverViewState {
  switch (action.type) {

    case CompanionActionTypes.GetCompanionsOverView: {
      return {...state, Loaded: false, Loading: true};
    }

    case CompanionActionTypes.GetCompanionsOverViewSuccess: {
      return  {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case CompanionActionTypes.GetCompanionsOverViewFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export function companionProtectionProcessDeviceReducer(
  state = initialStateforCompanionProtectionProcessDevice,
  action: CompanionActions
): CompanionProtectionProcessDeviceState {
  switch (action.type) {

    case CompanionActionTypes.GetCompanionProtectionProcessDevice: {
      return {...state, Loaded: false, Loading: true};
    }

    case CompanionActionTypes.GetCompanionProtectionProcessDeviceSuccess: {
      return  {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case CompanionActionTypes.GetCompanionProtectionProcessDeviceFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export function resendDataOfCompanionProtectionProcessReducer(
  state = initialStateforResendDataOfCompanionProtectionProcess,
  action: CompanionActions
): ResendDataOfCompanionProtectionProcessState {
  switch (action.type) {

    case CompanionActionTypes.ResendDataOfCompanionProtectionProcess: {
      return {...state, Loaded: false, Loading: true};
    }

    case CompanionActionTypes.ResendDataOfCompanionProtectionProcessSuccess: {
      return  {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case CompanionActionTypes.ResendDataOfCompanionProtectionProcessFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const getCompanionOverViewState = (state: CompanionOverViewState) => state;
export const getProtectionProcessDeviceState = (state: CompanionProtectionProcessDeviceState) => state;
export const getResendDataOfCompanionProtectionProcessState = (state: ResendDataOfCompanionProtectionProcessState) => state;
